var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetailsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.163 17.5H4.53452L4.64173 17.1443C5.01531 15.9048 6.15155 15 7.5 15C8.84845 15 9.98469 15.9048 10.3583 17.1443L10.4655 17.5H10.837H21.5V18.5H10.837H10.4655L10.3583 18.8557C9.98469 20.0952 8.84845 21 7.5 21C6.15155 21 5.01531 20.0952 4.64173 18.8557L4.53452 18.5H4.163H2.5V17.5H4.163ZM13.163 11.5H13.5345L13.6417 11.1443C14.0153 9.90477 15.1515 9 16.5 9C17.8485 9 18.9847 9.90477 19.3583 11.1443L19.4655 11.5H19.837H21.5V12.5H19.837H19.4655L19.3583 12.8557C18.9847 14.0952 17.8485 15 16.5 15C15.1515 15 14.0153 14.0952 13.6417 12.8557L13.5345 12.5H13.163H2.5V11.5H13.163ZM5.5 18C5.5 19.1031 6.39686 20 7.5 20C8.60314 20 9.5 19.1031 9.5 18C9.5 16.8969 8.60314 16 7.5 16C6.39686 16 5.5 16.8969 5.5 18ZM14.5 12C14.5 13.1031 15.3969 14 16.5 14C17.6031 14 18.5 13.1031 18.5 12C18.5 10.8969 17.6031 10 16.5 10C15.3969 10 14.5 10.8969 14.5 12Z",
    fill: "#C10037",
    stroke: "#C10037"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3583 5.14428L12.4655 5.5H12.837H21.625V6.5H12.837H12.4655L12.3583 6.85572C11.9847 8.09523 10.8485 9 9.5 9C8.15155 9 7.01531 8.09523 6.64173 6.85572L6.53452 6.5H6.163H2.5V5.5H6.163H6.53452L6.64173 5.14428C7.01531 3.90477 8.15155 3 9.5 3C10.8485 3 11.9847 3.90477 12.3583 5.14428ZM7.5 6C7.5 7.10314 8.39686 8 9.5 8C10.6031 8 11.5 7.10314 11.5 6C11.5 4.89686 10.6031 4 9.5 4C8.39686 4 7.5 4.89686 7.5 6Z",
    fill: "#C10037",
    stroke: "#C10037"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailsIcon);
export default __webpack_public_path__ + "static/media/details-icon.f6367b878d88de32a5436ab1da9b12c9.svg";
export { ForwardRef as ReactComponent };